export default "__VITE_ASSET__DwMQKbbN__"